import { render, staticRenderFns } from "./DeleteImage.vue?vue&type=template&id=1009adb9&scoped=true&"
import script from "./DeleteImage.vue?vue&type=script&lang=js&"
export * from "./DeleteImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009adb9",
  null
  
)

export default component.exports